const DOMAIN = 'cobranded.services.userSettings.privateArea.banner.downloadApp.';

export const TITLE = `${DOMAIN}title`,
  DESCRIPTION_DESKTOP = `${DOMAIN}descriptionDesktop`,
  DESCRIPTION_MOBILE = `${DOMAIN}descriptionMobile`;
